document.querySelectorAll('[data-product-page]').forEach(root => {
  const variants = [...root.querySelectorAll('[data-variant]')];
  const quantity = root.querySelector('[data-quantity]');
  const contact = root.querySelector('[data-product-contact]');
  const money = cents => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: root.dataset.currency }).format(cents / 100);
  variants.forEach(input => {
    const strength = input.dataset.title.match(/^\s*(\d+(?:[.,]\d+)?)\s*mg\s*$/i);
    if (strength && Number(strength[1].replace(',', '.')) > 0) input.closest('label').querySelector('[data-unit-price]').textContent = `${money(Number(input.dataset.price) / Number(strength[1].replace(',', '.')))} / mg`;
  });
  const update = () => {
    const variant = variants.find(input => input.checked);
    const count = Math.max(1, Math.min(99, Math.floor(Number(quantity.value) || 1)));
    quantity.value = count;
    if (!variant) return;
    root.querySelector('[data-product-total]').textContent = money(Number(variant.dataset.price) * count);
    root.querySelector('[data-variant-unavailable]').hidden = !variant.disabled;
    if (contact) {
      contact.hidden = variant.disabled;
      const productUrl = `${root.dataset.url}?variant=${variant.value}`;
      const message = `Cześć! Interesuje mnie produkt: ${root.dataset.title}, wariant: ${variant.dataset.title}, ilość: ${count}. ${productUrl}`;
      contact.href = `https://wa.me/${root.dataset.phone}?text=${encodeURIComponent(message)}`;
    }
  };
  variants.forEach(input => input.addEventListener('change', () => {
    update(); const url = new URL(location.href); url.searchParams.set('variant', input.value); history.replaceState(null, '', url);
  }));
  variants.forEach(input => input.closest('label').addEventListener('click', event => {
    if (event.target === input || input.disabled) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  quantity.addEventListener('input', update);
  quantity.addEventListener('change', update);
  root.querySelector('[data-quantity-minus]').addEventListener('click', () => { quantity.value = Math.max(1, (Number(quantity.value) || 1) - 1); update(); });
  root.querySelector('[data-quantity-plus]').addEventListener('click', () => { quantity.value = Math.min(99, (Number(quantity.value) || 1) + 1); update(); });
  update();
});
